<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="aafb/admin/discount_code/"
                       data-key="discount_codes"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-on="$listeners"
                       v-bind="$attrs">
    <template #item.start="{value}">
      {{ $parseDate(value, 'yyyy-MM-dd') }}
    </template>
    <template #item.end="{value}">
      {{ $parseDate(value, 'yyyy-MM-dd') }}
    </template>
    <template #item.type="{item, value}">
      {{ $t(`admin_acc_discount_code.type_${value}`)}}
      {{ item.type !== 'MEMBERSHIP' ? ' - ' : ''}}
      {{ item.type === 'FACILITY' ? item.item_type.name : ''}}
      {{ item.type === 'GYM_PASS' ? item.gym_pass_type.name : ''}}
    </template>
    <template #item.minimum_amount="{item, value}">
      {{ item.type === 'FACILITY' ? value : ''}}
    </template>
    <template #item.discount="{item}">
      {{ item.discount_value ? `$${item.discount_value}` : `${item.discount_percentage}%`}}
    </template>
    <template v-slot:item.actions="{item}">
      <v-tooltip top>
        <template #activator="{on, attrs}">
          <v-btn icon
                 v-on="on"
                 v-bind="attrs"
                 @click="editItem(item)">
            <v-icon>fas fa-edit</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('edit') }}</span>
      </v-tooltip>
      <v-tooltip top>
        <template #activator="{on, attrs}">
          <v-btn icon
                 v-on="on"
                 v-bind="attrs"
                 @click="deleteItem(item)">
            <v-icon>fas fa-trash</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('delete') }}</span>
      </v-tooltip>
      <v-tooltip top>
        <template #activator="{on, attrs}">
          <v-btn icon
                 v-on="on"
                 v-bind="attrs"
                 @click="listItemRecords(item)">
            <v-icon>fas fa-list</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('admin_acc_discount_code.list_records') }}</span>
      </v-tooltip>
    </template>
  </RemotePaginatedList>
</template>

<script>
import _ from 'lodash';
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";
import {BOOKING_STATUS, BOOKING_STATUS_LABEL} from "@/constants";
import EditDiscountCodeModal from "@/components/acc_booking/discount_code/EditDiscountCodeModal.vue";
import ListDiscountCodeRecordModal from "@/components/acc_booking/discount_code/ListDiscountCodeRecordModal.vue";

export default {
  name: 'AdminDiscountCodeList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
    extraParams: Object,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        {text: root.$t('admin_acc_discount_code.start'), value: 'start', datetime_date_range: true},
        {text: root.$t('admin_acc_discount_code.end'), value: 'end', datetime_date_range: true},
        {text: root.$t('admin_acc_discount_code.code'), value: 'code', contains: true},
        {
          text: root.$t('admin_acc_discount_code.type'), value: 'type',
          options: [
            {text: root.$t('admin_acc_discount_code.type_FACILITY'), value: 'FACILITY'},
            {text: root.$t('admin_acc_discount_code.type_GYM_PASS'), value: 'GYM_PASS'},
            {text: root.$t('admin_acc_discount_code.type_MEMBERSHIP'), value: 'MEMBERSHIP'},
          ],
        },
      ]
    })

    // Data Table
    const headers = ref([
      // {text: root.$t('admin_acc_discount_code.created_by'), value: 'created_by', sortable: false},
      {text: root.$t('admin_acc_discount_code.start'), value: 'start'},
      {text: root.$t('admin_acc_discount_code.end'), value: 'end'},
      {text: root.$t('admin_acc_discount_code.code'), value: 'code'},
      {text: root.$t('admin_acc_discount_code.type'), value: 'type', sortable: false},
      {text: root.$t('admin_acc_discount_code.minimum_amount'), value: 'minimum_amount', sortable: false},
      // {text: root.$t('admin_acc_discount_code.discount'), value: 'discount', sortable: false},
      // {text: root.$t('admin_acc_discount_code.use_per_account'), value: 'use_per_account', sortable: false},

      {text: '', value: 'actions', sortable: false},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const deleteItem = function (item) {
      if (confirm(root.$t('admin_acc_discount_code.delete_confirm_msg'))) {
        root.$callAPI('aafb/admin/discount_code/delete/', {
          discount_code_id: item.id,
        }, (response) => {
          refresh();
        })
      }
    }
    const editItem = async function (item) {
      await root.$dialog.showAndWait(EditDiscountCodeModal, {
        discountCodeId: item.id,
        persistent: true,
        width: '80vw',
      })
    };
    const listItemRecords = async function (item) {
      await root.$dialog.showAndWait(ListDiscountCodeRecordModal, {
        discountCodeId: item.id,
        persistent: true,
        width: '80vw',
      })
    }

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      BOOKING_STATUS,
      BOOKING_STATUS_LABEL,

      deleteItem,
      editItem,
      listItemRecords,
    }
  }
}
</script>
